class Announcement {
  constructor() {
    this.announcement = document.querySelector('.announcement');
    this.button = document.querySelector('.announcement__button');
  }

  init() {
    if (this.button) {
      this.button.addEventListener('click', () => this.hideAnnouncement());
    }
  }

  hideAnnouncement() {
    this.announcement.classList.add('announcement-hide');
    this.announcement.addEventListener('transitionend', () => {
      this.announcement.classList.remove('announcement-active');
    }, { once: true });
  }
}

export const announcement = new Announcement();